import { GanttTask } from '../types/gantt';
import { formatDateToIso, addDays } from '../utils/dateUtils';

/**
 * Dynamically generates sample tasks based on the current date.
 */
export function getDefaultSampleTasks(baseDate: Date = new Date()): GanttTask[] {
  const baseIso = formatDateToIso(baseDate);

  return [
    {
      id: 'task-1',
      activity: 'Project Planning & Scope',
      start: baseIso,
      end: addDays(baseIso, 14),
      progress: 100,
    },
    {
      id: 'task-2',
      activity: 'Architecture & UI Design',
      start: addDays(baseIso, 7),
      end: addDays(baseIso, 24),
      progress: 80,
    },
    {
      id: 'task-3',
      activity: 'Core Development',
      start: addDays(baseIso, 18),
      end: addDays(baseIso, 45),
      progress: 50,
    },
    {
      id: 'task-4',
      activity: 'QA & User Acceptance Testing',
      start: addDays(baseIso, 38),
      end: addDays(baseIso, 55),
      progress: 20,
    },
    {
      id: 'task-5',
      activity: 'Production Go-Live',
      start: addDays(baseIso, 56),
      end: addDays(baseIso, 56),
      progress: 0,
    },
  ];
}

export const INITIAL_SAMPLE_TASKS = getDefaultSampleTasks();
